export const Two = () => {
  return (
    <svg
      width={32}
      height={40}
      viewBox="0 0 32 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.987 37.02l-4.664-10.368-.75-1.25 9.87-3.83 4.913 10.785-5.663.874-3.706 3.79z"
        fill="#127FBE"
        stroke="#000"
        strokeWidth={0.0832861}
      />
      <path
        d="M4.091 33.863l3.267-10.89.252-1.435 9.967 3.569-3.35 11.368-4.853-3.048-5.283.436z"
        fill="#127FBE"
        stroke="#000"
        strokeWidth={0.0832861}
      />
      <circle cx={16.5736} cy={13.2425} r={13.2425} fill="#CCC" />
      <path
        d="M16.24 26.485V0C11.703 0 2.822 3.14 3.355 13.7c.533 10.561 8.653 12.785 12.887 12.785z"
        fill="#B6B7BC"
      />
      <path
        d="M7.745 10.453c-.985 2.804-1.066 9.112 6.496 11.91M25.402 16.241c.986-2.804 1.066-9.111-6.496-11.91"
        stroke="#757575"
        strokeWidth={0.666289}
        strokeLinecap="round"
      />
      <path
        d="M12.846 16.82a57.429 57.429 0 002.863-2.446 9.745 9.745 0 001.487-1.687c.402-.588.603-1.16.603-1.718 0-.423-.098-.753-.294-.99-.196-.238-.49-.357-.882-.357s-.702.15-.929.45c-.216.288-.325.7-.325 1.237h-2.554c.021-.877.207-1.61.558-2.197.36-.589.83-1.022 1.408-1.3a4.498 4.498 0 011.95-.418c1.228 0 2.152.314 2.77.944.63.63.945 1.45.945 2.46 0 1.105-.377 2.132-1.13 3.08-.753.94-1.713 1.858-2.879 2.756h4.18v2.151h-7.77V16.82z"
        fill="#757575"
      />
    </svg>
  );
};
